import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full" }

import {
    IonPage,
    IonContent 
} from '@ionic/vue';
import TopNavigation from '@/partials/TopNavigation.vue';
import Otp from '@/components/forms/Otp.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'VerificationCode',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(TopNavigation, {
        "back-button": true,
        "back-url": "/forgot-password"
      }),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-center mb-11 mt-5" }, [
              _createElementVNode("h4", { class: "font-bold mb-4" }, "Verification Code"),
              _createElementVNode("p", { class: "text-sm text-gray-900" }, "Verification code sent to em***@gmail.com. Enter the 6-digit verification code to reset your password.")
            ], -1)),
            _createVNode(Otp)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})